
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[...terms]",
      function () {
        return require("private-next-pages/category/[...terms].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[...terms]"])
      });
    }
  